import { Account, EnhancedAccount, Region } from "library/accounts/types";
import {
  getPaymentNotificationPreferences,
  getSingleAddress,
} from "library/api";
import { Product } from "library/hooks/types";
import {
  convertObjectKeysCase,
  getProductName,
  snakeToCamelCase,
} from "library/transforms";
import {
  AccountHelpers,
  NotificationPreferences,
} from "pages/Notifications/types";

export function accountHelpers(account: Account): AccountHelpers {
  const isCreditCard = account.type === "CREDIT_CARD";

  const isPersonalLoan = account.type === "PERSONAL_LOAN";

  const isJointAccount = !!account.joint_account;

  const hasNoToken = !account.credit_card?.token;

  const isAccountClosed = account.status === "CLOSED";

  const accountCardTestId = isCreditCard
    ? `credit-card-ending-${account.credit_card?.linked_card_last4}`
    : isPersonalLoan
    ? `personal-loan-number-${account.account_number}`
    : "unknown";

  return {
    isCreditCard,
    isPersonalLoan,
    isJointAccount,
    hasNoToken,
    accountCardTestId,
    isAccountClosed,
  };
}

export function getNotificationsAccountData(
  accounts: Account[],
  products?: Product[],
): EnhancedAccount[] {
  if (!products || accounts.length === 0) {
    return [];
  }
  return accounts.reduce<EnhancedAccount[]>((acc, account) => {
    const { isAccountClosed } = accountHelpers(account);
    const product = products.find((p) => p.id === account.product_id);
    const productName: string = product ? getProductName(product) : "";
    const region: Region = product?.region === "NZ" ? "NZ" : "AU";
    if (!isAccountClosed) {
      acc.push({ ...account, productName, region });
    }
    return acc;
  }, []);
}

export function getNotificationPreferences(
  token: string,
): () => Promise<NotificationPreferences> {
  return async () => {
    try {
      const result = await Promise.all([
        getSingleAddress(token, true),
        getPaymentNotificationPreferences(token),
      ]);
      return {
        personalDetails: convertObjectKeysCase(
          result[0].data,
          snakeToCamelCase,
        ),
        preferences: convertObjectKeysCase(result[1].data, snakeToCamelCase),
        token,
      };
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
